import axiosInstance from "../axios_instance";

export async function getDashboardData(body) {
  const params = new URLSearchParams();

  if (body?.roleID) {
    params.append('roleID', body?.roleID);
  }
  const url = `dashboard/${params.toString() ? `?${params.toString()}` : ''}`;
  try {
    return await axiosInstance.get(url);
  } catch (error) {
    return error;
  }
}

export async function getSetupStatus(userID) {
  try {
    const url = `dashboard/setup/status/${userID}`
    return await axiosInstance.get(url);
  } catch (error) {
    return error;
  }
}

export async function updateSetupStep(body) {
  try {
    const url = `dashboard/setup/step/update`
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}
